module.exports = __webpack_public_path__ + "static/img/diamond.ad08e13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/leagueoflegends/diamond.png
// module id = /W4J
// module chunks = 35